import { globalMargin } from '../../../shared-components/global-styles';

const mobileStyles = Object.freeze({
  discoverContainer: {
    flexDirection: 'column',
    marginTop: globalMargin,
  },
  bodyContainer: {},
  resultsContainer: {
    marginVertical: 0,
  },
  toggleFiltersToolbar: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginBottom: globalMargin,
  },
  toggleFiltersButton: {
    fontWeight: 600,
  },
  filtersContainer: {
    fontFamily: 'Helvetica, Arial, sans-serif',
    padding: 10,
    position: 'absolute',
    top: 10,
    right: 0,
    boxShadow: '0px 0px 7px rgba(0, 0, 0, 0.15)',
    backgroundColor: 'white',
    zIndex: 2,
  },
  show: {
    width: 365, // 10 px smaller than iPhone SE
    opacity: 1,
  },
  hide: {
    width: 0,
    opacity: 0,
  },
  dateLabel: {
    marginTop: globalMargin,
  },
});

export default mobileStyles;
